import { Mail } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@heroui/react";
import { useConnection } from "@/contexts/connection-context";

export function AuthenticationNotice() {
  const { connectWallet } = useConnection();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="w-full"
    >
      <div className="bg-gradient-to-br from-red-50 to-red-100/50 dark:from-red-900/20 dark:to-red-800/10 rounded-2xl p-4 sm:p-6 lg:p-8 border border-red-200/20 dark:border-red-700/20">
        <div className="flex flex-col items-center gap-4 sm:gap-6">
          {/* Glassmorphic icon container */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
            className="relative"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-red-400/30 to-red-600/30 backdrop-blur-sm rounded-2xl flex items-center justify-center shadow-lg border border-red-300/30">
              <Mail className="w-8 h-8 sm:w-10 sm:h-10 text-red-600" />
            </div>
            {/* Decorative glow */}
            <div className="absolute inset-0 bg-red-500/20 rounded-2xl blur-xl -z-10" />
          </motion.div>

          {/* Text content */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, ease: "easeOut", delay: 0.2 }}
            className="text-center space-y-2 sm:space-y-3 max-w-sm"
          >
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">
              Connect your wallet to continue
            </h3>
            <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400">
              Connect your wallet to complete tasks and earn rewards
            </p>
          </motion.div>

          <Button
            size="lg"
            className="bg-green-500 hover:bg-green-600 text-white font-medium"
            startContent={<Mail className="w-5 h-5" />}
            onPress={() => connectWallet()}
          >
            Connect Wallet
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
